(function () {
  // Nav: fondo al hacer scroll
  function onScroll() {
    var nav = document.getElementById('main-nav');
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 50);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // FAQ: acordeón (delegado, funciona también en el editor de Shopify)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-btn');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    var list = btn.closest('.faq-list') || document;
    var isOpen = item.classList.contains('open');
    list.querySelectorAll('.faq-item').forEach(function (i) {
      i.classList.remove('open');
      var b = i.querySelector('.faq-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  // Logos de plataformas: texto de respaldo si la imagen no carga
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img && img.tagName === 'IMG' && img.closest('.plataforma-logo')) {
      img.style.display = 'none';
      var fb = img.nextElementSibling;
      if (fb) fb.style.display = 'block';
    }
  }, true);
})();
